import React, { useState } from "react";
import ImageUpload from "../../../../../ui/imageUpload/ImageUpload";
import classes from "./UploadTab.module.css";

const MAX_SIZE_BYTES = 50 * 1024;

const UploadTab = ({ onFileChange, previewUrl }) => {

    const [file, setFile] = useState(null);

    const handleChange = (f) => {
        setFile(f);
        onFileChange(f);
    };

    return (
        <div className={classes.UploadTab}>
            <ImageUpload
                imageFile={file || previewUrl || null}
                onImageChange={handleChange}
                onRemove={() => handleChange(null)}
                maxSizeBytes={MAX_SIZE_BYTES}
            />
        </div>
    );
};

export default UploadTab;